<template>
  <b-card
    title="مدیریت خطاها"
  >
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
        <b-row>
          <div class="filter-row">
            <b-col md="2">
              <b-form-group
                  label="عنوان"
                  label-for="Title"
              >
                <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                    autocomplete="off"
                />
              </b-form-group>
            </b-col>
          <b-col
            md="2"
          >
            <b-form-group
              label="وضعیت"
              label-for="TicketStatus"
            >
              <v-select
                v-model="filterOptions.Closed"
                dir="rtl"
                :options="enums('errorStatus')"
                label="text"
                :reduce="x => x.value"
              />
            </b-form-group>
          </b-col>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="warning"
              class="mb-1 mr-1"
              @click="update(1)"
            >فیلتر
            </b-button>
          </div>
        </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'errorDetails', params: { id: data.item.Id }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>
          <template #cell(Title)="data" style="width:200px">
            <span>{{ data.value  }}</span>
          </template>
          <template #cell(FirstDate)="data">
            {{ data.value | dateToTime }} {{ data.value | date }}
          </template>
          <template #cell(LastDate)="data">
            {{ data.value | dateToTime }} {{ data.value | date }}
          </template>
          <template #cell(Closed)="data">
            <b-badge
                :variant="data.value ? 'success' : 'warning'"
            >
              {{ data.value ? 'بسته' : 'باز' }}
            </b-badge>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">loading ...</strong>
            </div>
          </template>
          <template #cell(actions)="data">
            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'errorDetails', params: { id: data.item.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>

              <feather-icon
                  icon="CheckSquareIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="close(data.item.Id)"
              />
            </div>
          </template>
        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
export default {
  name: 'ListErrors',
  data() {
    return {
      filterOptions: {
        Title: null,
        Page: 1,
        Closed: false,
      },
      totalRows: 1000 * 1000,
      loading: false,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'Title',
          label: 'title',
        },
        {
          key: 'ErrorCount',
          label: 'Count Occur',
          sortable: true,
        },
        {
          key: 'FirstDate',
          label: 'First Occur',
          sortable: true,
        },
        {
          key: 'LastDate',
          label: 'Last Occur',
          sortable: true,
        },
           {
          key: 'Closed',
          label: 'status',
        },

        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.errorlog.getlist,this.filterOptions).then((response)=>{
         this.items = response.data
         this.totalRows = response.totalRow
         this.loading = false
      })
    },
    close(errorId) {
      this.loading = true
      this.$http.post(this.$api.errorlog.update,{
        "Id" : errorId
      }).then(()=>{
        this.update()
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>